module.exports = __webpack_public_path__ + "websocket.95f8f815f0d5061366e2.worker.js"